import React from 'react';
import { Redirect } from 'react-router';

const Home = () => {
  return <Redirect to={{ pathname: '/dashboard' }} />;
};

export default Home;
